import _toConsumableArray from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.slice.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "flex px-6 p-3 lg:px-0 lg:py-2 align-items-center text-indigo-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"
};
var _hoisted_2 = {
  class: "block"
};
var _hoisted_3 = {
  class: "text-indigo-50 font-medium"
};
var _hoisted_4 = {
  class: "list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:border-1 border-50 lg:shadow-2 lg:absolute surface-overlay hidden origin-top w-full lg:w-10rem cursor-pointer z-5"
};
var _hoisted_5 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$data$store, _$data$store2, _$data$store3, _$data$store4, _$data$store5, _$data$store6, _$data$store7, _$data$store8;
  var _component_Avatar = _resolveComponent("Avatar");
  var _component_router_link = _resolveComponent("router-link");
  var _directive_styleclass = _resolveDirective("styleclass");
  var _directive_ripple = _resolveDirective("ripple");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_1, [(_$data$store = $data.store) !== null && _$data$store !== void 0 && (_$data$store = _$data$store.currentUser) !== null && _$data$store !== void 0 && _$data$store.avatar ? (_openBlock(), _createBlock(_component_Avatar, {
    key: 0,
    size: "medium",
    shape: "circle",
    class: "mr-2",
    image: (_$data$store2 = $data.store) === null || _$data$store2 === void 0 ? void 0 : _$data$store2.currentUser.avatar
  }, null, 8, ["image"])) : _createCommentVNode("", true), !((_$data$store3 = $data.store) !== null && _$data$store3 !== void 0 && (_$data$store3 = _$data$store3.currentUser) !== null && _$data$store3 !== void 0 && _$data$store3.avatar) ? (_openBlock(), _createBlock(_component_Avatar, {
    key: 1,
    size: "medium",
    shape: "circle",
    class: "mr-2",
    style: {
      "color": "#333"
    },
    label: ((_$data$store4 = $data.store) === null || _$data$store4 === void 0 || (_$data$store4 = _$data$store4.currentUser) === null || _$data$store4 === void 0 ? void 0 : _$data$store4.first_name.slice(0, 1)) + ((_$data$store5 = $data.store) === null || _$data$store5 === void 0 || (_$data$store5 = _$data$store5.currentUser) === null || _$data$store5 === void 0 ? void 0 : _$data$store5.last_name.slice(0, 1))
  }, null, 8, ["label"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString((_$data$store6 = $data.store) === null || _$data$store6 === void 0 || (_$data$store6 = _$data$store6.currentUser) === null || _$data$store6 === void 0 ? void 0 : _$data$store6.first_name) + " " + _toDisplayString((_$data$store7 = $data.store) === null || _$data$store7 === void 0 || (_$data$store7 = _$data$store7.currentUser) === null || _$data$store7 === void 0 ? void 0 : _$data$store7.last_name), 1)]), _cache[0] || (_cache[0] = _createElementVNode("i", {
    class: "pi pi-angle-down ml-auto text-white lg:ml-2"
  }, null, -1))])), [[_directive_styleclass, {
    selector: '@next',
    enterFromClass: 'hidden',
    enterActiveClass: 'scalein',
    leaveToClass: 'hidden',
    leaveActiveClass: 'fadeout',
    hideOnOutsideClick: true
  }]]), _createElementVNode("ul", _hoisted_4, [((_$data$store8 = $data.store) === null || _$data$store8 === void 0 || (_$data$store8 = _$data$store8.currentUser) === null || _$data$store8 === void 0 ? void 0 : _$data$store8.user_type) == 'staff' && $options.canUseLeave() ? (_openBlock(), _createElementBlock("li", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/my-profile",
    class: "flex p-3 align-items-center text-600 hover:text-900 no-underline hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(function () {
      return _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("i", {
        class: "pi pi-user mr-2"
      }, null, -1), _createElementVNode("span", {
        class: "font-medium"
      }, "My profile", -1)]));
    }),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), _createElementVNode("li", null, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/logout",
    class: "flex p-3 align-items-center text-600 hover:text-900 no-underline hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(function () {
      return _toConsumableArray(_cache[2] || (_cache[2] = [_createElementVNode("i", {
        class: "pi pi-sign-out mr-2"
      }, null, -1), _createElementVNode("span", {
        class: "font-medium"
      }, "Sign out", -1)]));
    }),
    _: 1
  })), [[_directive_ripple]])])])], 64);
}